<template>
  <v-dialog width="350px" persistent v-model="editDialog">
    <v-btn  slot="activator" icon class="">
      <v-icon small light class="text--lighten-1">edit</v-icon>
    </v-btn>
    <v-card>
      <v-container class="mt-0">
        <v-layout row wrap>
          <v-flex xs12 class="mb-2">
            <v-card-title class="justify-center"><h2>Edit Indication</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedIndications" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12>
            <v-card-text>             
            <v-text-field
              name="editedIndicationsName"
              v-model="editedIndicationsName"
              label="Indication"
              id="editedIndicationsName"
            ></v-text-field>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
              <v-btn dark flat class="red darken-3" @click="onDeleteIndication(indication)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['indication'],
  data () {
    return {
      editDialog: false,
      editedIndications: this.indication,
      editedIndicationsName: this.indication.indicationName
    }
  },
  computed: {
    loadIndications () {
      return this.$store.getters.loadedIndications
    }
  },
  methods: {
    onDeleteIndication (indication) {
      console.log('Delete this: ' + JSON.stringify(indication))
      this.$store.dispatch('deleteIndicationData', indication)
      this.$router.push('/indications')
    },
    onSaveChanges () {
      this.editDialog = false
      this.$store.dispatch('updateIndicationData', {
        indicationId: this.indication.indicationId,
        indicationName: this.editedIndicationsName
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditIndicationsDialog.vue?29fcaeae